import { apiContainer } from '@vlabs/api-bindings';

export interface TDetection {
  id: string;
  rect: {
    x: number;
    y: number;
    width: number;
    height: number;
  };
  sdk_descriptor: string;
  type: string;
  uiDetectionUrl: string;
}

export const getFaceDetectionsFromFile = async (file: File): Promise<TDetection[]> => {
  const samples = await apiContainer.lunaClient.detector.getSamples(file);

  const { data: { images_estimations } } = await apiContainer.lunaClient.sdk.estimateFace(file);

  const detectionList: TDetection[] = [];
  if (!samples.length) return detectionList;

  images_estimations.forEach(({ estimations }) => estimations.forEach(({ face }, index) => {
    detectionList.push({
      sdk_descriptor: face.detection.attributes.descriptor.sdk_descriptor,
      type: 'face',
      id: samples[index].face.sample_id,
      rect: samples[index].face.detection.rect,
      uiDetectionUrl: samples[index].face.uiUrl,
    });
  }));

  return detectionList;
};
